import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, Mail } from "lucide-react";
import api from "../lib/api";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [status, setStatus] = useState("working"); // working | done | error
  const [email, setEmail] = useState("");

  useEffect(() => {
    if (!token) { setStatus("error"); return; }
    api.post("/newsletter/unsubscribe", { token })
      .then((r) => { setEmail(r.data?.email || ""); setStatus("done"); })
      .catch(() => setStatus("error"));
  }, [token]);

  return (
    <div className="pti-container py-24 flex justify-center" data-testid="unsubscribe-page">
      <div className="w-full max-w-md text-center border border-gray-200 p-10">
        <div className="mx-auto w-12 h-12 flex items-center justify-center bg-pti-black text-pti-red rounded-full mb-5">
          <Mail size={22} />
        </div>
        {status === "working" && (
          <div data-testid="unsub-working">
            <Loader2 className="animate-spin mx-auto text-pti-red" size={24} />
            <p className="text-gray-500 mt-3">Processing your request…</p>
          </div>
        )}
        {status === "done" && (
          <div data-testid="unsub-done">
            <CheckCircle2 className="mx-auto text-green-600" size={28} />
            <h1 className="font-display text-2xl font-black mt-3">You're unsubscribed</h1>
            <p className="text-gray-600 mt-2">{email ? <><span className="font-semibold">{email}</span> has been </> : "You've been "}removed from the PictureThisInk newsletter. We're sorry to see you go.</p>
            <Link to="/" data-testid="unsub-home" className="inline-block mt-6 bg-pti-red text-white px-6 py-3 font-bold hover:bg-pti-redhover transition-colors">Back to PictureThisInk</Link>
          </div>
        )}
        {status === "error" && (
          <div data-testid="unsub-error">
            <h1 className="font-display text-2xl font-black">Link not valid</h1>
            <p className="text-gray-600 mt-2">This unsubscribe link is missing or has already been used. If you still receive emails, please use the link in the most recent one.</p>
            <Link to="/" className="inline-block mt-6 bg-pti-black text-white px-6 py-3 font-bold hover:bg-pti-red transition-colors">Back to PictureThisInk</Link>
          </div>
        )}
      </div>
    </div>
  );
}
